import * as t from 'io-ts';

import {makeApiType, makeEnumRuntimeType} from './apiTypes';

/*
 * Constants.
 */

const partnerTagRegex = /\[partner\]/gi;

/*
 * Runtime types.
 */

export enum IncidentImpactsEnum {
  NONE = 'none',
  MINOR = 'minor',
  MAJOR = 'major',
  CRITICAL = 'critical',
}

export enum IncidentTypesEnum {
  FRONT = 'front',
  PARTNER = 'partner',
}

const RIncidentDirty = t.readonly(
  t.type({
    id: t.string,
    name: t.string,
    shortlink: t.string,
    body: t.string,
    impact: makeEnumRuntimeType(IncidentImpactsEnum),
    type: makeEnumRuntimeType(IncidentTypesEnum),
  }),
);

/*
 * Type.
 */

export interface IncidentModel extends t.TypeOf<typeof RIncidentDirty> {}
export const RIncident = t.clean<IncidentModel>(RIncidentDirty as any);

/*
 * IO methods.
 */

export function parseIncident(src: any): IncidentModel {
  const {name} = src;
  const firstUpdate = src.incident_updates && src.incident_updates[0];
  const body = (firstUpdate && firstUpdate.body) || '';

  const isPartnerIncident = Boolean(name.match(partnerTagRegex) || body.match(partnerTagRegex));

  return {
    id: src.id,
    impact: src.impact,
    name: removePartnerTagFromString(name),
    shortlink: src.shortlink,
    body: removePartnerTagFromString(body),
    type: isPartnerIncident ? IncidentTypesEnum.PARTNER : IncidentTypesEnum.FRONT,
  };
}

/*
 * API type.
 */

export const ApiIncident = makeApiType('incident', RIncident, parseIncident);

/*
 * Helpers.
 */

function removePartnerTagFromString(str: string) {
  return str.replace(partnerTagRegex, '').trim();
}
